<template>
  <v-card class="section-card pa-6 mt-6" elevation="0">
    <div class="d-flex align-center mb-6">
      <div class="icon-circle mr-4">
        <v-icon color="#2563eb">mdi-bank-outline</v-icon>
      </div>
      <div>
        <h3 class="text-h6 font-weight-bold mb-0">ข้อมูลการเงินและการรับเงิน</h3>
        <p class="text-caption grey--text mb-0">ข้อมูลบัญชีธนาคารและ PromptPay สำหรับรับค่าสินค้า</p>
      </div>
    </div>

    <v-form ref="form" v-model="valid">
      <v-row>
        <v-col cols="12" md="4">
          <span class="detail-label">ธนาคาร</span>
          <v-select
            v-model="form.bankName"
            :items="banks"
            placeholder="เลือกธนาคาร"
            outlined
            dense
            hide-details="auto"
            class="mt-1"
          ></v-select>
        </v-col>

        <v-col cols="12" md="4">
          <span class="detail-label">เลขบัญชีธนาคาร</span>
          <v-text-field
            v-model="form.bankAccountNumber"
            placeholder="เลขบัญชีธนาคาร"
            outlined
            dense
            hide-details="auto"
            class="mt-1"
            prepend-inner-icon="mdi-numeric"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="4">
          <span class="detail-label">ชื่อบัญชีธนาคาร</span>
          <v-text-field
            v-model="form.bankAccountName"
            placeholder="ชื่อ-นามสกุลตามหน้าสมุดบัญชี"
            outlined
            dense
            hide-details="auto"
            class="mt-1"
            prepend-inner-icon="mdi-account-outline"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="12">
          <span class="detail-label">PromptPay ID</span>
          <v-text-field
            v-model="form.promptPayId"
            placeholder="เบอร์โทรศัพท์ หรือ เลขบัตรประชาชน"
            outlined
            dense
            hide-details="auto"
            class="mt-1"
            prepend-inner-icon="mdi-qrcode-scan"
          ></v-text-field>
          <p class="text-caption grey--text mt-1">ใช้สำหรับสร้าง QR Code และตรวจสอบความถูกต้องของสลิป</p>
        </v-col>
      </v-row>

      <v-alert
        v-if="!form.bankName || !form.bankAccountNumber || !form.bankAccountName"
        type="warning"
        text
        dense
        icon="mdi-alert-circle-outline"
        class="mt-4 mb-0"
      >
        กรุณาระบุข้อมูลธนาคารให้ครบถ้วนเพื่อผลประโยชน์ในการรับเงิน
      </v-alert>

      <div class="d-flex justify-end mt-6">
        <v-btn
          color="#2563eb"
          dark
          depressed
          @click="save"
          :loading="loading"
          min-width="120"
          height="40"
          style="border-radius: 8px; text-transform: none;"
        >
          บันทึกข้อมูลการเงิน
        </v-btn>
      </div>
    </v-form>
  </v-card>
</template>

<script>
export default {
  name: "SellerFinancialCard",
  props: {
    data: { type: Object, default: () => ({}) },
    loading: { type: Boolean, default: false }
  },
  data() {
    return {
      valid: true,
      form: {
        bankName: "",
        bankAccountNumber: "",
        bankAccountName: "",
        promptPayId: ""
      },
      banks: [
        "กสิกรไทย", "ไทยพาณิชย์", "กรุงเทพ", "กรุงไทย", "กรุงศรีอยุธยา",
        "ทหารไทยธนชาต", "ออมสิน", "ธ.ก.ส.", "ซิตี้แบงก์", "ยูโอบี",
        "แลนด์ แอนด์ เฮ้าส์", "ไอซีบีซี (ไทย)",
      ]
    };
  },
  watch: {
    data: {
      immediate: true,
      handler(v) {
        if (!v) return;
        this.form = {
          bankName: v.bank?.bankName || "",
          bankAccountNumber: v.bank?.bankAccountNumber || "",
          bankAccountName: v.bank?.bankAccountName || "",
          promptPayId: v.promptPayId || ""
        };
      }
    }
  },
  methods: {
    save() {
      this.$emit("save", { ...this.form });
    }
  }
};
</script>

<style scoped>
.section-card {
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
}
.icon-circle {
  width: 44px;
  height: 44px;
  background: #eff6ff;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.detail-label {
  font-size: 13px;
  font-weight: 600;
  color: #475569;
}
:deep(.v-text-field--outlined fieldset) {
  border-color: #e2e8f0;
}
:deep(.v-text-field--outlined.v-input--is-focused fieldset) {
  border-color: #2563eb;
}
</style>
